const StaffModal = ({ data, onClose }) => {
  return (
    <div className="modal-backdrop">
      <div className="modal-card">
        <h3>{data ? "Edit Staff" : "Add Staff"}</h3>

        <div className="form-grid">
          <input placeholder="Staff Name" />
          <input placeholder="Email" />
          <input placeholder="Mobile" />
          <input placeholder="Department" />
          <input placeholder="Designation" />
          <input placeholder="Salary" />
        </div>

        <div className="modal-actions">
          <button onClick={onClose}>Cancel</button>
          <button className="primary-btn">Save</button>
        </div>
      </div>
    </div>
  );
};

export default StaffModal;
